import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=15cb689f&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Merchant.vue?vue&type=style&index=1&id=15cb689f&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb689f",
  null
  
)

export default component.exports